import { render } from "./AllProcedureApplications.vue?vue&type=template&id=bcd68f60"
import script from "./AllProcedureApplications.vue?vue&type=script&lang=js"
export * from "./AllProcedureApplications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__